import {UserModel} from './UserModel';

export class UserReport {
  reason: '';
  reportedUser: UserModel;
  reportingUser: UserModel;

  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/app/_models/_firebaseObjects/UserReport.ts